import React from "react";

import { useSelector } from "react-redux";

import { Dialog, DialogTitle } from "components/MaterialDialog";

import { ModalTypes } from "constants/navigation";

import { getBillingDocumentById, getContextByModalType } from "selectors";

import { ModalContent } from "./ModalContent";

import { Row } from "components/Layout";
import { XeroDeepLink } from "components/Link/XeroDeepLink";

interface RetainProceedsModalAdapterProps {
  onClose: () => void;
}

interface RetainProceedsModalContext {
  billingDocumentId?: string;
  isOpen?: boolean;
}

export function RetainProceedsModalAdapter(
  props: RetainProceedsModalAdapterProps,
): React.JSX.Element | null {
  const { onClose } = props;

  const context: RetainProceedsModalContext =
    useSelector(
      getContextByModalType(ModalTypes.RetainProceeds) as (
        state: RootState,
      ) => RetainProceedsModalContext | undefined,
    ) || {};

  const { billingDocumentId, isOpen } = context;

  const billingDocument: BillingDocument | null = useSelector(
    getBillingDocumentById(billingDocumentId) as (
      state: RootState,
    ) => BillingDocument | null,
  );

  const existingRetainedProceeds: RetainedProceeds | null =
    billingDocument?.proceedsRetainedByBillingDocument || null;

  if (!billingDocumentId) {
    return null;
  }

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      maxWidth="sm"
      key={billingDocumentId}
    >
      <DialogTitle onClose={onClose}>
        <Row>
          Retain Proceeds{" "}
          <XeroDeepLink
            creditNoteId={existingRetainedProceeds?.xeroInvoiceId}
          />
        </Row>
      </DialogTitle>
      <ModalContent billingDocumentId={billingDocumentId} onClose={onClose} />
    </Dialog>
  );
}
